/* eslint-disable import/prefer-default-export */
export function getPageQueryParams() {
  if (!window) {
    return {};
  }

  const search = window.location.search.substring(1);
  const params = {};
  if (search) {
    const parts = search.split('&');
    parts.forEach((pair) => {
      const [key, value] = pair.split('=');
      if (value) {
        params[key] = decodeURIComponent(value);
      }
    });
  }
  return params;
}
